import { jsx as _jsx } from "react/jsx-runtime";
import '@hotmart-org-ca/cosmos/dist/alert';
import '@hotmart-org-ca/cosmos/dist/toast';
import '@hotmart-org-ca/cosmos/dist/alert/variations/info.css';
import '@hotmart-org-ca/cosmos/dist/alert/variations/success.css';
import '@hotmart-org-ca/cosmos/dist/alert/variations/danger.css';
import '@hotmart-org-ca/cosmos/dist/alert/variations/warning.css';
async function showToast({ type, message }) {
    const ToastUtils = await import('@hotmart-org-ca/cosmos/dist/toast/utils');
    ToastUtils.default[type]({ message, position: 'top right', dismissible: false });
}
export function Toast() {
    return document.querySelector('hot-toast') ? null : _jsx("hot-toast", {});
}
Toast.show = showToast;
